/**
 * Shared toast / snackbar feedback styling (react-hot-toast + MUI Snackbar + Alert).
 * Keep colors aligned here so success/error look the same everywhere.
 */
export const APP_TOAST_SUCCESS_COLOR = "#0E9046";
export const APP_TOAST_ERROR_COLOR = "#D32F2F";
export const APP_TOAST_WARNING_COLOR = "#ED6C02";
export const APP_TOAST_INFO_COLOR = "#0288D1";
export const APP_TOAST_BACKGROUND = "#FFFFFF";
export const APP_TOAST_FONT_SIZE = "15px";

// Fixed neutral text color, same "physical card, doesn't invert in dark mode"
// convention APP_TOAST_BACKGROUND already used (matches DocumentBox.jsx's
// fixed-white-card pattern) — the redesign moved color off the message text
// and onto the icon badge only, so this no longer needs to be theme-aware.
export const APP_TOAST_TEXT_COLOR = "#1A1A1A";

// Below the top nav bar, always — react-hot-toast's Toaster containerStyle
// and MuiSnackbar's theme override both read this one constant (Rahim,
// 2026-08-31: toasts "must always render below the top navbar").
export const APP_TOAST_TOP_OFFSET = 76;

// react-hot-toast renders in a portal outside the MUI <ThemeProvider> DOM
// subtree, so it never inherits materialTheme.js's typography.fontFamily —
// falls back to the browser's default system-font stack unless set
// explicitly here (Rahim, 2026-08-31: "use better font for the heading").
// Keep in sync with materialTheme.js's typography.fontFamily.
export const APP_TOAST_FONT_FAMILY = "'Instrument Sans', 'Figtree', 'Lato', 'Roboto', sans-serif";

export const APP_TOAST_MAX_WIDTH = "min(560px, calc(100vw - 32px))";

// Icon-glyph color per severity — deliberately its OWN lighter palette, not
// a reuse of APP_TOAST_*_COLOR above (those stay the app's darker semantic
// colors, still used for the preview panel's button text) — the icon read
// too dark/heavy at solid fill (Rahim, 2026-08-31: "use light green type
// this one is too dark" then "same for the others use a little light
// colours").
export const APP_TOAST_ICON_TINTS = {
  success: "#1CB454",
  error: "#E53535",
  warning: "#E78A08",
  info: "#3072F0",
};

export const APP_SNACKBAR_ANCHOR_ORIGIN = {
  vertical: "top",
  horizontal: "right",
};
